if(document.querySelector('.dropzone-upload')) {
    document.querySelectorAll('.dropzone-upload').forEach((el) => {
        const formElement = el.closest('form'),
                removedFilesElement = formElement.querySelector('[name="removedFiles"]'),
                formSubmitButton = formElement.querySelector('[type="submit"]'),
                formUrl = formElement.action.replace('/edit', '') + '?uploadImages=Y',
                isMultiple = el.dataset.multiple === 'true';

        if(!formElement.dataset.filesCount) {
            formElement.dataset.filesCount = 0;
            formElement.dataset.removedFiles = JSON.stringify([]);
        }

        new Dropzone(el, {

            // The configuration we've talked about above
            autoProcessQueue: false,
            uploadMultiple: isMultiple,
            withCredentials: true,
            parallelUploads: 100,
            maxFiles: (isMultiple ? 100 : 1),
            url: formUrl,
            paramName: (el.dataset.name || 'image'),
            addRemoveLinks: true,
            headers: {
                'x-csrf-token': document.querySelector('meta[name=csrf-token]').getAttributeNode('content').value,
            },

            // The setting up of the dropzone
            init: function() {

                this.options.url = formUrl;

                let currentDropzoneEl = this;

                if(el.querySelector('.dropzone-uploaded-element')) {
                    el.querySelectorAll('.dropzone-uploaded-element').forEach((uploadedEl) => {
                        const mockFile = {
                            name: uploadedEl.dataset.name,
                            size: uploadedEl.dataset.size,
                            path: uploadedEl.dataset.path,
                            imageId: uploadedEl.dataset.imageId,
                        };
                        currentDropzoneEl.options.addedfile.call(currentDropzoneEl, mockFile);
                        currentDropzoneEl.options.thumbnail.call(currentDropzoneEl, mockFile, mockFile.path);
                        uploadedEl.remove();
                        ++formElement.dataset.filesCount;
                    })
                }

                if(!formSubmitButton.dataset.hasEvent) {
                    formSubmitButton.dataset.hasEvent = true;
                    // First change the button to actually tell Dropzone to process the queue.
                    formSubmitButton.addEventListener('click', function(e) {
                        // Make sure that the form isn't actually being sent.
                        currentDropzoneEl.processQueue();

                        removedFilesElement.value = formElement.dataset.removedFiles;

                        e.preventDefault();
                        e.stopPropagation();

                        formElement.submit()
                    });
                }

                // Listen to the sendingmultiple event. In this case, it's the sendingmultiple event instead
                // of the sending event because uploadMultiple is set to true.
                currentDropzoneEl.on('sendingmultiple sending', function() {
                    el.querySelector('.dropzone-error-message').innerHTML = '';
                    // Gets triggered when the form is actually being sent.
                    // Hide the success button or the complete form.
                });
                currentDropzoneEl.on('successmultiple success', function(files, response) {
                    formElement.submit();
                    // Gets triggered when the files have successfully been sent.
                    // Redirect user or notify of success.
                });
                currentDropzoneEl.on('complete', function(files, response) {
                    formElement.submit();
                    // Gets triggered when the files have successfully been sent.
                    // Redirect user or notify of success.
                });
                currentDropzoneEl.on('errormultiple', function(files, errorMessage) {
                    el.querySelector('.dropzone-error-message').innerHTML = errorMessage;
                    // Gets triggered when there was an error sending the files.
                    // Maybe show form again, and notify user of error
                });
                currentDropzoneEl.on("error", function(file, errorMessage) {
                    file.previewElement.remove();
                    el.querySelector('.dropzone-error-message').innerHTML = errorMessage;
                });
                currentDropzoneEl.on("addedfile", function(file) {
                    el.querySelector('.dropzone-error-message').innerHTML = '';
                    ++formElement.dataset.filesCount;
                    el.querySelector('.dropzone-delete-all > input[type="checkbox"]').checked = false
                });
                currentDropzoneEl.on("removedfile", function(file) {
                    let removedFiles = JSON.parse(formElement.dataset.removedFiles || '[]');
                    removedFiles.push(file.imageId);
                    formElement.dataset.removedFiles = JSON.stringify(removedFiles);
                    el.querySelector('.dropzone-error-message').innerHTML = '';
                    --formElement.dataset.filesCount;
                    el.querySelector('.dropzone-delete-all > input[type="checkbox"]').checked = !el.querySelectorAll('.dz-image-preview').length
                });
            }

        });
    })
}
